import React from "react"
import { useTranslation } from "react-i18next"
import { CircleFlag } from "react-circle-flags"
import { ChevronDown } from "react-feather"

import { getLanguage } from "utils/i18n"

import "./LanguageSelector.scoped.scss"

// Countries code are ISO 3166-1 alpha-2 code
// See https://www.iso.org/obp/ui/#search
export const countries = {
	fr: "fr",
	gb: "gb",
	de: "de",
	es: "es",
}


export const LanguageSelector = ({ className = "" }) => {
	const { t, i18n } = useTranslation()

	const defaultCurrentLanguage = getLanguage()
	const [currentLanguageWithoutArea, setCurrentLanguageWithoutArea] = React.useState(defaultCurrentLanguage.substring(0, 2))

	const availableCountries = Object.keys(countries)

	React.useEffect(() => {
		// if key detected by the navigator is just 'en-US', we set 'gb' by default.
		if (currentLanguageWithoutArea === "en") setCurrentLanguageWithoutArea("gb")
	}, [currentLanguageWithoutArea])

	const changeLanguage = (lng) => {
		setCurrentLanguageWithoutArea(lng)
		i18n.changeLanguage(countries[lng])
	}

	return (
		<div className={`c-language-selector ${className}`}>
			<CircleFlag countryCode={currentLanguageWithoutArea} height="16" width="16" aria-hidden={true} />
			<form>
				<label htmlFor="countrySelector" aria-label="Select country">
					<span className="mx-2">
						{t(`availableTranslatedCountries.${currentLanguageWithoutArea}`)}
					</span>
					<ChevronDown size={16} />
					<select
						id="countrySelector"
						value={currentLanguageWithoutArea}
						onChange={(event) => changeLanguage(event?.target?.value)}
					>
						{availableCountries.map((country) => {
							return (
								<option key={country} value={country}>
									{t(`availableTranslatedCountries.${country}`)}
								</option>
							)
						})}
					</select>
				</label>
			</form>
		</div>
	)
}
